/**
 * What each piece of UI chrome is drawn with. Values are game-icons.net names (browse them at
 * https://game-icons.net); content icons live on the catalog entries instead. After changing one, run
 * `pnpm --filter @wyn/web icons` to rebundle.
 */
export const UI = {
  brand: 'crown',
  realm: 'crown',
  road: 'horizon-road',
  fight: 'crossed-swords',
  attack: 'crossed-swords',
  character: 'character',
  market: 'scales',
  trades: 'trade',
  talk: 'conversation',
  chronicle: 'scroll-quill',
  boards: 'podium',
  deeds: 'laurels-trophy',
  // The day's three tasks
  noticeBoard: 'scroll-unfurled',
  // The stewards' view of the realm's coin
  flows: 'two-coins',
  bank: 'locked-chest',
  gaol: 'prisoner',
  infirmary: 'health-normal',
  herald: 'fleur-de-lys',
  notice: 'envelope',
  loading: 'hourglass',
  locked: 'padlock',
  levelUp: 'star-formation',
  favoured: 'round-star',
  // The rules, terms and privacy notice
  rules: 'scroll-quill',
  terms: 'fleur-de-lys',
  privacy: 'padlock',
  // Reporting a line or a player to the stewards
  report: 'flying-flag',
  // The stewards' view, and a name a steward has taken away
  stewards: 'gavel',
  rename: 'quill-ink',
  // Bars
  life: 'heart-plus',
  vigour: 'muscle-up',
  nerve: 'death-skull',
  focus: 'third-eye',
  mood: 'sun',
  // Stats
  strength: 'biceps',
  defence: 'shield',
  speed: 'running-shoe',
  dexterity: 'juggler',
  // Fight slots
  mainHand: 'broadsword',
  offHand: 'shield',
  ranged: 'bow-arrow',
  fists: 'fist',
} as const;
